module.exports = __webpack_public_path__ + "static/media/large_logo.e243c494.png";